import { render, staticRenderFns } from "./PaymentMomoConfig.vue?vue&type=template&id=6c4f5989&"
import script from "./PaymentMomoConfig.vue?vue&type=script&lang=js&"
export * from "./PaymentMomoConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports